import React from "react";
import { Switch, Route } from "react-router-dom";
import "./Route.scss";

import RoutesPage from "./RoutesPage";
import RoutePage from "./RoutePage";

const Routes = () => (
  <Switch>
    <Route path="/dispatch/routes/:id">
      <RoutePage />
    </Route>
    <Route path="/dispatch/routes">
      <RoutesPage />
    </Route>
  </Switch>
);

export default Routes;
